module.exports = "/assets/paywall-main-boy.webp"